export const formatDate = (dateValue) => {
  if (!dateValue) return '-';
  const d = parseItemDate({ date: dateValue });
  if (!d) return String(dateValue);
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

export const toDatetimeLocal = (d = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const toDateLocal = (d = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const parseItemDate = (item) => {
  const raw = item?.date ?? item?.createdAt;
  if (!raw) return null;

  if (raw instanceof Date) return raw;
  if (raw?.toDate instanceof Function) return raw.toDate();

  const str = String(raw).trim();
  let parsed = new Date(str);
  if (!Number.isNaN(parsed.getTime())) return parsed;

  const cleaned = str.replace(/\s*\(.*\)$/, "").replace(/,/g, "").trim();
  parsed = new Date(cleaned);
  if (!Number.isNaN(parsed.getTime())) return parsed;

  const dateMatch = cleaned.match(/(\d{1,4})[/-](\d{1,2})[/-](\d{1,4})/);
  if (!dateMatch) return null;

  const [, part1, part2, part3] = dateMatch;
  let isoDate;

  if (part1.length === 4) {
    isoDate = `${part1}-${part2.padStart(2, "0")}-${part3.padStart(2, "0")}`;
  } else if (part3.length === 4) {
    if (parseInt(part1, 10) > 12) {
      isoDate = `${part3}-${part2.padStart(2, "0")}-${part1.padStart(2, "0")}`;
    } else {
      isoDate = `${part3}-${part1.padStart(2, "0")}-${part2.padStart(2, "0")}`;
    }
  }

  if (!isoDate) return null;

  const remainder = cleaned.slice(dateMatch[0].length).trim();
  const tryString = remainder ? `${isoDate} ${remainder}` : isoDate;
  const finalDate = new Date(tryString);
  return Number.isNaN(finalDate.getTime()) ? null : finalDate;
};

/**
 * Formats a Date as a human-readable "time ago" string.
 * e.g. "just now", "45m ago", "2h 30m ago", "yesterday"
 *
 * @param {Date|null} date
 * @returns {string|null}
 */
export function formatTimeAgo(date) {
  if (!date) return null;
  const diffMs  = Date.now() - date.getTime();
  if (diffMs < 0) return null;
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1)  return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  const h   = Math.floor(diffMin / 60);
  const rem = diffMin % 60;
  if (h < 24) return rem > 0 ? `${h}h ${rem}m ago` : `${h}h ago`;
  if (h < 48) return 'yesterday';
  return `${Math.floor(h / 24)} days ago`;
}

/**
 * Returns an ISO 8601 timestamp string for N hours ago.
 * Used by useRecentItems for the timestamp lower-bound query.
 *
 * @param {number} hours - Number of hours to go back
 * @returns {string} ISO 8601 timestamp string
 */
export function getHoursAgoISO(hours) {
  const now = new Date();
  const hoursAgo = new Date(now.getTime() - hours * 60 * 60 * 1000);
  return hoursAgo.toISOString();
}
